module.exports = __webpack_public_path__ + "img/source_sw-item7.882f3ccb.png";